<div class="edit-container">
    <h1 class="edit-title">Inregistrare in cadrul registrului de Serviciu/Institutie</h1>
    <form class="edit-card__form" [formGroup]="form" (submit)="submitForm()">
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Registru/Serie/Lot</mat-label>
                    <mat-select formControlName="id_serie">
                        <mat-option *ngFor="let option of registreActiveSwitch" [value]="option.id">
                            {{option.name}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="
                        !form.controls['id_serie'].valid &&
                        form.controls['id_serie'].touched
                    ">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <ng-container *ngIf="form.value.id_serie > 0">
            <div class="row">
                <div [ngClass]="form.get('new_number')?.value !== 3 ? 'col-md-12' : 'col-md-6'">
                    <mat-form-field appearance="fill">
                        <mat-label>Registru/Serie/Lot</mat-label>
                        <mat-select formControlName="new_number"
                            (selectionChange)="onRegistraturaTypeSelected($event.value)">
                            <mat-option *ngFor="let option of currentNumberOptions"
                                [value]="option.id">{{option.name}}</mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="!form.controls['new_number'].valid && form.controls['new_number'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6" *ngIf="form.get('new_number')?.value === 3">
                    <mat-form-field appearance="fill">
                        <mat-label>Număr Document (Răspuns/Ieșire)</mat-label>
                        <input type="number" matInput formControlName="registratura_number" />
                        <mat-error
                            *ngIf="!form.controls['registratura_number'].valid && form.controls['registratura_number'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </ng-container>

        <div class="row">
            <div class="col d-flex justify-content-between">
                <button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
                    Închide
                </button>
                <button class="buttons" type="submit" mat-flat-button color="primary" [disabled]="form.invalid">
                    Actualizează
                </button>
            </div>
        </div>
    </form>

    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>